import { parseJson, vySerialize } from '@vy/utils';
import { getLocalStorageString } from '.';

export function getRequireLocalStorageItem<ItemType = string>(key: string) {
  const item = getLocalStorageItem<ItemType>(key);

  if (!item) {
    throw new Error(`Missing required item: ${key}`);
  }

  return item;
}

export function getLocalStorageItem<ItemType>(key: string) {
  const json = getLocalStorageString(key);

  return json ? parseJson<ItemType>(json) : undefined;
}

export function setLocalStorageItem(key: string, item: unknown) {
  const json = vySerialize(item);

  return localStorage.setItem(key, json);
}
